// extracted by mini-css-extract-plugin
export default {"buttonContainer":"completeKyc_buttonContainer__fn6kS"};